import BackendService from './BackendService';

async function getSubscriptionsAndAddons() {
  return BackendService.getData('/subscription-and-addons/');
}

const SubscriptionService = {
  getSubscriptionsAndAddons,
};

export default SubscriptionService;
